import React from 'react';
import { number } from 'prop-types';
import MuiLinearProgress from '@material-ui/core/LinearProgress';
import { styled } from '@material-ui/core';

const StyledLinearProgress = styled(MuiLinearProgress)({
  height: 9,
  '&.MuiLinearProgress-colorPrimary': {
    backgroundColor: 'WhiteSmoke',
  },
  '& .MuiLinearProgress-barColorPrimary': {
    backgroundColor: 'DarkGray',
  },
});

const LinearProgress = ({ value }) => <StyledLinearProgress variant="determinate" value={value} />;

LinearProgress.propTypes = {
  value: number,
};

export default LinearProgress;
